export default __webpack_public_path__ + "static/media/gallery_00.09f38dc3.jpg";